import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody, Button, Modal } from "reactstrap"
import MetaTags from 'react-meta-tags'
import { Link } from "react-router-dom"
import PropTypes from 'prop-types'

// datatable related plugins
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, {
  PaginationProvider, PaginationListStandalone,
  SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import ClipLoader from "react-spinners/ClipLoader";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import "../datatables.scss"
import { deleteUser, getUsers } from '../../../helpers/backend_helper';
import usePage from "hooks/usePage";
import BreadcrumbNav from "components/Common/BreadcrumbNav";

const breadcrumbItems = [
  { id:'1', title: 'Catálogos', link: '', active: false },
  { id:'2', title: 'Usuarios', link: '', active: true }
];


const CatalogUserList = () => {
  const { page, sizePerPage, setPage } = usePage();

  const [error, setError] = useState (null)
  const [modal_standard, setmodal_standard] = useState(false);
  const [row, setRow] = useState(null)

  async function handleDelete(evt, row) {
    setLoading(true);
    try {
      const response = await deleteUser(row.id);
      setData(data.filter( item => item.id !== row.id))
    } catch(error) {
      setError(error.toString())
    }
    setLoading(false);
    tog_standard();
  }  

  function actionButtons(cell, row, rIdx) {
    return (    
      <span>
        <Link className="btn btn-sm btn-danger" to={{ pathname: "/catalogs/users/form-edit", state: { ...row, page } }} title="Edit">
          <i className="fas fa-edit"></i>
        </Link>
        <Button 
          type="button" 
          className="btn btn-sm btn-danger ms-1" 
          onClick={(evt) => {tog_standard(); setRow(row); } } 
          title="Eliminar">
          <i className="fas fa-times"></i>
        </Button>
      </span>
    )
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  function tog_standard() {
    setmodal_standard(!modal_standard);
    removeBodyCss();
  }

  const columns = [{
    dataField: 'name',
    text: 'Nombre',
    sort: true
  }, {
    dataField: 'email',
    text: 'Email',
    sort: true
  }, {
    dataField: 'enterprise.company_name',
    text: 'Empresa',
    sort: true
  }, {
    dataField: 'type_string',
    text: 'Tipo',
    sort: true
  }, {
    dataField: 'id',
    text: 'Acciones',
    formatter: actionButtons
  }]; 

  // Table Data
  let [color, setColor] = useState("#f46a6a");
  const [loading, setLoading] = useState (false);
  const [data, setData] = useState ([]);
  const [totalSize, setTotalSize] = useState(0);

  useEffect(() => {
    async function getData()  {
      setLoading(true);
      const response = await getUsers();
      setLoading(false);
      console.log(response);
      setData(response);
      setTotalSize(response.length);
    }

    getData();
  }, []);

  const defaultSorted = [{
    dataField: 'id',
    order: 'asc'
  }];

  const pageOptions = {
    sizePerPage,
    totalSize,
    custom: true,
    page,
    onPageChange: setPage,
    hideSizePerPage: true
  }

  // Custom Pagination Toggle
  const sizePerPageList = [
    { text: '5', value: 5 },
    { text: '10', value: 10 },
    { text: '15', value: 15 },
    { text: '20', value: 20 },
    { text: '25', value: 25 },
    { text: 'All', value: (data).length }];

  const { SearchBar } = Search;

  const afterSearch = (results) => {
    setTotalSize(results.length);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Catalogo Usuarios</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbNav title="Usuarios"  items={breadcrumbItems}/>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>

                <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField='id'
                    columns={columns}
                    data={data}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField='id'
                        columns={columns}
                        data={data}
                        search={ { afterSearch } }
                      >
                        {toolkitProps => (
                          <React.Fragment>

                            <Row className="mb-2">
                              <Col md="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar
                                      {...toolkitProps.searchProps}
                                      placeholder='Buscar'
                                      onSearch={(data) => {
                                        setPage(1);
                                        toolkitProps.searchProps.onSearch(data);
                                      }}
                                    />
                                    <i className="bx bx-search-alt search-icon" />                                    
                                  </div>
                                </div>
                              </Col>
                              <Col md="8" className="text-end">
                                <Link to="/catalogs/users/form-create" className="btn btn-danger btn-sm">
                                  <i className="fas fa-plus"></i> Crear Usuario
                                </Link>
                              </Col>
                            </Row>

                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={
                                      "table align-middle table-nowrap"
                                    }
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    noDataIndication={ loading ? <ClipLoader color={color} loading={loading} size={30} /> : 'Sin datos' }
                                  />

                                </div>
                              </Col>
                            </Row>

                            <Row className="align-items-md-center mt-30">
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                </div>
                                <div className="text-md-right ms-auto">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </React.Fragment>
                        )
                        }
                      </ToolkitProvider>
                    )
                    }</PaginationProvider>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <Modal
        isOpen={modal_standard}
        toggle={() => {
          tog_standard();
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Borrar Usuario
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_standard(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <p>
            ¿Está seguro de borrar el usuario?
          </p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_standard();
            }}
            className="btn btn-secondary "
            data-dismiss="modal"
          >
            <i className="fas fa-times"></i> Cerrar
          </button>
          <button
            onClick={(evt) => handleDelete(evt, row)}
            type="button"
            className="btn btn-danger"
          >
            <i className="fas fa-check"></i> Borrar
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

CatalogUserList.propTypes = {
  searchProps: PropTypes.any,
  baseProps: PropTypes.any
};


export default CatalogUserList
